import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=2f4dd870&"
import script from "./LoadingOverlay.vue?vue&type=script&lang=ts&"
export * from "./LoadingOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports